import { DashboardSection } from '@constants/Dashboard/dashboard.enums'

export type OperationsSectionWaves = {
  revenue: number | null
  scheduleOperations: number | null
  insuranceClaims: number | null
  hygiene: number | null
  arOver90: number | null
  patientsAge: number | null
  patientStatus: number | null
  seatUtilization: number | null
}

function show(section: DashboardSection, hiddenSections: Set<string>): boolean {
  return !hiddenSections.has(section)
}

export function buildOperationsSectionWaves(
  hiddenSections: Set<string>,
): OperationsSectionWaves {
  const visible = (section: DashboardSection): boolean =>
    show(section, hiddenSections)
  return {
    revenue: visible(DashboardSection.RevenueOverview) ? 0 : null,
    scheduleOperations: visible(DashboardSection.ScheduleOperations) ? 0 : null,
    insuranceClaims: visible(DashboardSection.InsuranceClaims) ? 0 : null,
    hygiene:
      visible(DashboardSection.NetHygieneProduction) ||
      visible(DashboardSection.ProductionPerHygieneVisit)
        ? 1
        : null,
    arOver90: visible(DashboardSection.ArOver90Day) ? 1 : null,
    patientsAge: visible(DashboardSection.PatientsAge) ? 1 : null,
    patientStatus: visible(DashboardSection.PatientStatus) ? 1 : null,
    seatUtilization: visible(DashboardSection.SeatUtilization) ? 1 : null,
  }
}
